<template>
  <div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'token',
    mounted: async function () {
      var self = this
      try {
        const token = self.$route.params.token
        await axios.get(`${process.env.FONESTORM_API}/devices`, { headers: { token } })
        localStorage.setItem('fonestorm-token', token) // store the token in localstorage
        self.$router.push({ name: 'Selection' })
      } catch (error) {
        localStorage.removeItem('fonestorm-token') // if the request fails, remove any possible user token if possible
        self.$router.push({ name: 'Login' })
      }
    }
  }
</script>
